import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { getEnumValues } from '../../services/common/miscUtils';
import Yup from '../../services/common/validation';
import { PersonalDetailsFormNewModel } from './mixed/formModel';
import { TitleEnum } from '../../types/forms';

export const createPersonalDetailsFormValidator = (): ObjectSchema<PersonalDetailsFormNewModel> => {
  return Yup.object({
    title: Yup.string().required(t('validation:required')).oneOf(getEnumValues(TitleEnum)),
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    dateOfBirth: Yup.string().required(t('validation:required')),
    addressLine1: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    addressLine2: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    addressLine3: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    eirCode: Yup.string().eirCode(t('validation:invalidEircode')).required(t('validation:required')),
    town: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    county: Yup.string().required(t('validation:required')),
  });
};
